export enum AnnouncementAudience {
  ALL_USERS = "ALL_USERS",
  ALL_STAFF = "ALL_STAFF",
  TEACHERS = "TEACHERS",
  PARENTS = "PARENTS",
  STUDENTS = "STUDENTS",
  SPECIFIC_CLASSES = "SPECIFIC_CLASSES",
  SPECIFIC_GRADE_LEVELS = "SPECIFIC_GRADE_LEVELS",
}
